export default function ChildElementBlurDirective($parse, $timeout) {
	'ngInject';

	return {
		restrict: 'A',
		compile: function($element, attrs) {
			var fn = $parse(attrs.childElementBlur);
			var leftFlag = false;
			return function handler(scope, element) {
				element.on('focusout', function(event) {
					leftFlag = true;
					$timeout(function() {
						scope.$apply(function() {
							if (leftFlag) {
								fn(scope, { $event: event });
							}
						});
					}, 1);
				});
				element.on('focusin', function(event) {
					leftFlag = false;
				});
			};
		}
	};
}
